export default "__VITE_ASSET__ipsiQPL1__"